import * as React from 'react'
import { Breadcrumb } from 'react-bootstrap'

type Breadcrumbs = Array<{
  item: string
  name: string
}>

type pageBreadcrumbProps = {
  breadcrumbs: Breadcrumbs
}

const isLast = (array1Length: number, arrayLength: number) => {
  return array1Length === arrayLength
}

// markup
const PageBreadcrumb = ({ breadcrumbs }: pageBreadcrumbProps): React.JSX.Element => {
  return (
    <>
      <Breadcrumb>
        {breadcrumbs.map((item: any, index: number) => (
          <Breadcrumb.Item
            key={item.item}
            href={`${item.item}`}
            active={isLast(breadcrumbs.length, index + 1)}
            title={item.name}
            aria-label={item.name}
          >
            {item.name}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </>
  )
}

export default PageBreadcrumb
